/**
 * useReconciledTransactions Hook
 * 
 * Hook para verificar quais transações de fluxo de caixa foram conciliadas
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../../lib/supabase';

export function useReconciledTransactions(companyIds: string[]) {
  const {
    data: reconciledIds,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['reconciled-transactions', companyIds],
    queryFn: async () => {
      console.log('[useReconciledTransactions] 🔍 Fetching for companies:', companyIds);
      
      if (!companyIds || companyIds.length === 0) {
        console.log('[useReconciledTransactions] ⚠️ No companyIds provided');
        return new Set<string>();
      }

      const { data, error } = await supabase
        .from('bank_reconciliations')
        .select('cash_flow_entry_id')
        .in('company_id', companyIds)
        .not('cash_flow_entry_id', 'is', null);

      if (error) {
        console.error('[useReconciledTransactions] ❌ Error fetching:', error);
        throw error;
      }

      const reconciledSet = new Set(data?.map(r => r.cash_flow_entry_id).filter(Boolean) || []);
      console.log('[useReconciledTransactions] ✅ Found reconciled IDs:', {
        count: reconciledSet.size,
        ids: Array.from(reconciledSet),
      });

      // Retornar como Set para lookup rápido
      return reconciledSet;
    },
    enabled: companyIds.length > 0,
  });

  return {
    reconciledIds: reconciledIds || new Set<string>(),
    isLoadingReconciled: isLoading,
    reconciledError: error,
  };
}

